import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import ActionButton from '../ActionButton'
import Steps from './Steps'

interface StepsSectionProps {
  onPrimaryButtonClick: () => void
}

const StepsSection: React.FC<StepsSectionProps> = ({ onPrimaryButtonClick }) => {
  return (
    <Box
      className="steps"
      paddingX="s64"
      paddingY="s32"
      width="full"
      flexDirection="column"
      gap="s64"
    >
      <Box className="steps__section-header" flexDirection="row" justifyContent="spaceAround">
        <Box flexDirection="column" gap="s8" maxWidth="s400" textAlign="center">
          <Text.Header2 htmlTag="h2">
            {i18n.t('project_management.landing_page.steps_section.title')}
          </Text.Header2>
          <Text.Normal>
            {i18n.t('project_management.landing_page.steps_section.subtitle')}
          </Text.Normal>
        </Box>
      </Box>
      <Steps />
      <Box flexDirection="column" alignItems="center" gap="s8">
        <ActionButton onPrimaryButtonClick={onPrimaryButtonClick} />
      </Box>
    </Box>
  )
}

export default StepsSection
